import { AppointmentHasuraStatus } from '../my-appointments/const/appointment';
import {
  FhirEncounterNotesOutput,
  GetAppointmentOutput,
} from '../../graphql/generated/hasura';
import { STATUS_CLASS } from '../my-appointments/components/upcoming-appointments/helper/getStatusClassName';

export enum CalendarType {
  Day = 'timeGridDay',
  Month = 'dayGridMonth',
  Week = 'timeGridWeek',
  List = 'listWeek',
}

export const momentPeriodByCalendarType = {
  [CalendarType.Day]: 'day',
  [CalendarType.Month]: 'month',
  [CalendarType.List]: 'week',
  [CalendarType.Week]: 'week',
} as const;

export const colors = {
  [AppointmentHasuraStatus.Completed]: 'border-l-bright-green',
  [AppointmentHasuraStatus.Booked]: 'border-l-clc-blue',
} as Record<AppointmentHasuraStatus, string>;

export type DayEventProps = Omit<
  GetAppointmentOutput,
  | 'appointmentId'
  | 'created'
  | 'lastProcessedDate'
  | 'participant'
  | 'statusHistory'
  | 'events'
  | 'media'
  | 'encounterNotes'
  | 'pendingRescheduleRequest'
> & {
  encounterNotes?: Partial<FhirEncounterNotesOutput> | null;
};
export const classes = new Map([
  [true, ''],
  [false, 'text-bright-green border-bright-green bg-green-50'],
]);

export const completedStatusMap = new Map([
  [
    true,
    {
      label: 'Complete',
      statusClassName: STATUS_CLASS[AppointmentHasuraStatus.Completed],
    },
  ],
  [
    false,
    {
      label: 'Pending summary',
      statusClassName:
        STATUS_CLASS[AppointmentHasuraStatus.PendingProviderApproval],
    },
  ],
]);
